import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UmstallenGruppeFrageDialogResult } from './umstallen-gruppe-frage-dialog';

@Component({
    selector: 'kiene-umstallen-gruppe-frage-dialog',
    templateUrl: './umstallen-gruppe-frage-dialog.component.html',
    styleUrls: ['./umstallen-gruppe-frage-dialog.component.scss'],
})
export class UmstallenGruppeFrageDialogComponent {
    constructor(public dialogRef: MatDialogRef<UmstallenGruppeFrageDialogComponent>) {}

    cancel() {
        this.dialogRef.close();
    }

    neueGruppe() {
        const result = new UmstallenGruppeFrageDialogResult();
        result.confirmed = true;
        result.result = 'neu';
        this.dialogRef.close(result);
    }

    gruppeAuswahl() {
        const result = new UmstallenGruppeFrageDialogResult();
        result.confirmed = true;
        result.result = 'auswahl';
        this.dialogRef.close(result);
    }
}
